/**
 * 人员&架构 统一卡片组件
 *
 * 将原先独立的 4 个 FormCard（实际控制人、主要人员、股东信息、组织架构）
 * 合并为 1 个 FormCard + 4 个 FormModule 子模块。
 *
 * 各子模块已拆分为独立组件，各自维护内部 state 和逻辑。
 *
 * 参考: VendorVisitDetailPage/VisitDetailInfo/OrganizationInfo/index.tsx
 */

import React, { FC } from 'react';
import { FormCard } from '@purchase/supplier';
import ActualControllerModule from './ActualControllerModule';
import KeyPersonnelModule from './KeyPersonnelModule';
import ShareholderModule from './ShareholderModule';
import OrganizationStructureModule from './OrganizationStructureModule';

const OrganizationInfo: FC<{
  formDetail: any;
  isExternal?: boolean;
  isDiff?: boolean;
}> = ({ formDetail, isExternal = false, isDiff = false }) => {
  return (
    <FormCard title="人员&架构">
      <ActualControllerModule
        formDetail={formDetail}
        isExternal={isExternal}
        isDiff={isDiff}
      />
      <KeyPersonnelModule formDetail={formDetail} isDiff={isDiff} />
      <ShareholderModule formDetail={formDetail} isDiff={isDiff} />
      <OrganizationStructureModule formDetail={formDetail} isDiff={isDiff} />
    </FormCard>
  );
};

export default OrganizationInfo;
